import React from 'react';
import { Button, ButtonGroup, Input } from 'reactstrap';
import RenderIcon from '../RenderIcon';

class _Pagination extends React.Component {
  render() {
    const { start, size, onChangePage, hasNextPage, onChangePageSize, totalCount, reportPaginationClass, isTypeModelCreateUpdateTable,paginationOption } = this.props;
    const paginationOptionArray = paginationOption && paginationOption.split(","); 
    const remainder = totalCount % size;
    const lastPage = remainder === 0 ? totalCount - size : totalCount - remainder
    const isOnLastPage = start >= lastPage;
    return (
      <div className={reportPaginationClass ? 'pull-full reportPaginationClass' : 'pull-full'}>
        {totalCount ?
          <div className={ `${isTypeModelCreateUpdateTable ? 'mt-4': ''} pull-left pagination-wrapper mb-4 ` } data-html2canvas-ignore="true">
            <span>{`Showing ${start+1} to ${(start + size) > totalCount ? totalCount : start + size} of ${totalCount} entries`}</span>
          </div> : null
        }
        <div className={`${isTypeModelCreateUpdateTable ? 'mt-4': ''} pull-right pagination-wrapper mb-4` } data-html2canvas-ignore="true">
          <ButtonGroup className="mr-2">
            <Button title="First Page" disabled={start <= 0} onClick={() => onChangePage(0, size)} color="primary" outline>
              &lsaquo;&lsaquo;
            </Button>
            <Button title="Previous Page" disabled={start <= 0} onClick={() => onChangePage(start - size, size)} color="primary" outline>
              &lsaquo;
            </Button>
          </ButtonGroup>
          {
           !paginationOption && isTypeModelCreateUpdateTable && <Input value={size} type="text" className="mr-2" name="text" style={{width: '60px'}} disabled/>
          }
          {
           paginationOption && paginationOptionArray  && isTypeModelCreateUpdateTable && <Input value={parseInt(paginationOptionArray[0])} type="text" className="mr-2" name="text" style={{width: '60px'}} disabled/>
          }
          {
             paginationOption &&  !isTypeModelCreateUpdateTable &&  <Input
              type="select"
              className="select mr-2"
              name="select"
              value={size}
              onChange={(e) => onChangePageSize(parseInt(e.target.value))}
            >
              {(paginationOptionArray.length > 0 ? paginationOptionArray : [10, 25, 50, 100, 500, 1000, 5000]).map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Input>
          }
          {
           !paginationOption &&  !isTypeModelCreateUpdateTable && <Input value={size} onChange={(event) => {
              onChangePageSize(parseInt(event.target.value));
            }} type="select" className="select mr-2" name="select">
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={5000}>5000</option>
            </Input>
          }
        <ButtonGroup className="pagination-buttons">
  <Button
    title="Next Page"
    disabled={isOnLastPage}
    onClick={() => onChangePage(start + size, size)}
    color="primary"
    outline
  >
    &rsaquo;
  </Button>

  <Button
    title="Last Page"
    disabled={isOnLastPage}
    onClick={() => onChangePage(lastPage, size)}
    color="primary"
    outline
  >
    &rsaquo;&rsaquo;
  </Button>
</ButtonGroup>

        </div>
      </div>
    )
  }
}

export default _Pagination;